import { FC } from 'react';

import { BugoKakaoShareContent } from '@service/bugo/utils/bugoMessage.util';
import { Icon } from '@shared/components/icons';

type Props = {
  kakaoContent: BugoKakaoShareContent;
  kakaoTemplateBugoButtonId?: string;
  shareCountUpdateFunc?: () => void;
};
declare global {
  interface Window {
    Kakao: any;
  }
}
const KakaoShareButton: FC<Props> = ({
  kakaoContent,
  kakaoTemplateBugoButtonId,
  shareCountUpdateFunc,
}: Props) => {
  const { ShareKakao } = Icon();

  // createCustomButton은 호출마다 리스너가 누적돼 공유창이 중복으로 뜨므로 클릭 시 직접 전송한다
  const shareToKakao = () => {
    const kakao = window.Kakao;
    if (!kakao) return;
    if (!kakao.isInitialized()) {
      kakao.init(process.env.REACT_APP_KAKAO_SHARE_JAVASCRIPT_KEY);
    }
    kakao.Share.sendCustom({
      //* fevent별 템플릿(관리자 커스텀 설정) > 상조별 템플릿 > 빌드 기본 템플릿
      templateId:
        kakaoContent.templateId ??
        (kakaoTemplateBugoButtonId
          ? Number(kakaoTemplateBugoButtonId)
          : Number(process.env.REACT_APP_KAKAO_SHARE_BUGO_BTN_ID)),
      templateArgs: {
        header: kakaoContent.header,
        content: kakaoContent.content,
        deathDate: kakaoContent.deathDate,
        deceasedName: kakaoContent.deceasedName,
        bugoTerm: kakaoContent.bugoTerm,
        bugoId: kakaoContent.bugoId,
      },
    });
    shareCountUpdateFunc?.();
  };

  return (
    <button onClick={shareToKakao}>
      <ShareKakao />
    </button>
  );
};

export default KakaoShareButton;
